// Libraries
import Axios from 'config/service.config'
import envConfig from 'config/env_config'

export const getPartnersByLocation = async (location, service, skip, limit, additionalServices) => {
  try {
    let params = {
      address: location
    }

    if (limit) {
      params = {
        ...params,
        skip,
        limit
      }
    }

    if (additionalServices.length) {
      params = { ...params, additionalServices }
    }

    const res = await Axios({
      baseURL: envConfig.partner,
      url: `partners/distance/${service}`,
      params,
      withCredentials: true
    })
    return res.data
  } catch (error) {
    return error.response
  }
}

export const getPartnersByStoreName = async (name) => {
  try {
    const res = await Axios({
      baseURL: envConfig.partner,
      url: 'partners/filter',
      params: {
        name
      },
      withCredentials: true
    })
    return res.data
  } catch (error) {
    return error.response
  }
}

export const getPartnerById = async (id) => {
  try {
    const res = await Axios({
      baseURL: envConfig.partner,
      url: `partners/client/${id}`,
      withCredentials: true
    })
    return res.data
  } catch (error) {
    return error.response
  }
}
